import req from '../lib/req';
import { Claim, Id } from '@/types';

/**
 * Updates the sum fields without triggering recalc logic in back-end.
 */
export function updateSumsWithoutRecalculation(id: Id, claim: Pick<Claim, 'sumFull' | 'sumCharged'>) {
  return req.put(`/v2/claim/${id}/update_sums_without_recalculation`, claim);
}

/**
 * Update tarn id and tapais id values for given claim.
 */
export function updateTarnAndTapaisId(id: Id, claim: Pick<Claim, 'tarnId' | 'tapaisId'>): Promise<void> {
  return req.put(`/v2/claims/${id}/update_tarn_and_tapais_id`, claim);
}
